import React from "react";
import styled from "styled-components";

const StyledDate = styled.section`
  display: flex;
  flex-direction: column;
  padding: 46px 0;
  gap: 15px;
`;

type TodayDateProps = {
  weekday: string;
  date: string;
};

export const TodayDate = ({ weekday, date }: TodayDateProps) => {
  return (
    <StyledDate>
      <span>
        <b>{weekday}</b>
      </span>
      <span>{date}</span>
    </StyledDate>
  );
};
